import { render, staticRenderFns } from "./CreateCardIssuanceCriteriaForm.vue?vue&type=template&id=72766ac6"
import script from "./CreateCardIssuanceCriteriaForm.vue?vue&type=script&lang=ts"
export * from "./CreateCardIssuanceCriteriaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports